/**
 * Das englische Wörterbuch.
 *
 * Jeder Teil ist gegen sein deutsches Gegenstück typisiert. Fehlt ein Schlüssel
 * oder steht einer zu viel darin, scheitert der Build — nicht der Betrieb.
 */
import { common } from './common.js';
import { domain } from './domain.js';
import { pages } from './pages.js';
import { dialogs } from './dialogs.js';
import { canvas } from './canvas.js';
import { server } from './server.js';
export const en = {
    ...common,
    ...domain,
    ...pages,
    ...dialogs,
    ...canvas,
    ...server,
};
//# sourceMappingURL=index.js.map